var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var CornerLogoContainer = /** @class */ (function (_super) {
    __extends(CornerLogoContainer, _super);
    function CornerLogoContainer(props) {
        return _super.call(this, props) || this;
    }
    CornerLogoContainer.prototype.render = function () {
        return React.createElement("div", { className: 'logo-wrapper' },
            React.createElement("img", { className: 'logo', src: this.props.img, alt: this.props.alt }),
            React.createElement("div", null, this.props.children));
    };
    return CornerLogoContainer;
}(React.PureComponent));
export default CornerLogoContainer;
//# sourceMappingURL=CornerLogoContainer.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/CornerLogoContainer.js
// module id = 288
// module chunks = 0